import { render, staticRenderFns } from "./MainModeFlashCardFavorite.vue?vue&type=template&id=32625df7&"
import script from "@/scripts/MainMode/MainModeCourse/MainModeFlashCardLanding/components/MainModeFlashCardFavorite.js?vue&type=script&lang=js&"
export * from "@/scripts/MainMode/MainModeCourse/MainModeFlashCardLanding/components/MainModeFlashCardFavorite.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports